import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import moment from 'moment';
import {
  Modal,
  Button,
  ControlLabel,
  FormGroup,
  FormControl,
  Row,
  Col,
} from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import {
  createAutoCorrectedDatePipe,
} from 'text-mask-addons';


import { GetAllJobNumbersQuery } from '../../components/TicketEntryForm/JobInput';
import TicketFormWrapper from '../../components/TicketEntryForm/containers/TicketFormWrapper';
import { parseErrors } from '../../utils';
import './style.css';
import TicketInput, { AllTicketsQuery } from '../../components/TicketInput/index';


const propTypes = exact({
  data: PropTypes.object,
  createTicket: PropTypes.func.isRequired,
  selectedId: PropTypes.number,
  onComplete: PropTypes.func,
});

export class TicketEntryLayout extends Component {
  /* NOTE: return object of cleared errorMessage, loading, ticket_number, but setting selectedId */
  static getDerivedStateFromProps(props, state) {
    if (props.selectedId !== state.selectedId) {
      return ({
        errorMessage: null,
        loading: false,
        ticket_number: null,
        selectedId: props.selectedId,
        date: null,
      });
    }
    return state;
  }

  constructor(props) {
    super(props);

    this.state = this.handleSetDefault();

    this.handleCreate = this.handleCreate.bind(this);
    this.handleClearError = this.handleClearError.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSetDefault = this.handleSetDefault.bind(this);
  }

  handleSetDefault() {
    return {
      errorMessage: null,
      loading: false,
      ticket_number: null,
    };
  }

  handleClearError() {
    const errorMessage = null;
    this.setState({ errorMessage });
  }

  handleValueChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  async handleCreate(formObj) {
    const { selectedId } = this.props;

    const variables = {
      input: {
        submission_item_id: selectedId,
        ticket: formObj,
      },
    };
    try {
      this.setState({
        loading: true,
      });
      await this.props.createTicket({ variables });
      /*
      * NOTE: Swiping tech debt credit card. These APIs are a mess. Rather than try to eat an
      * elephant and address the design issues, I am just wrapping the selectedId in an object to
      * be compatible with the provided onComplete callback.
       */
      this.props.onComplete({ id: selectedId });
    } catch (e) {
      const errorMessage = parseErrors(e);
      this.setState({ errorMessage });
    } finally {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    if (!this.props.data.submission_item) {
      return (
        <div>
          Loading...
        </div>
      );
    }

    const { errorMessage, loading, ticket_number: ticketNumber, date } = this.state;

    const { submission_item: submissionItem } = this.props.data;
    return (
      <div className="ticketEntryLayout-modal-container">
        <Row>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Date</ControlLabel>
              <FormControl
                componentClass={MaskedInput}
                name="date"
                value={date}
                onChange={this.handleValueChange}
                type="text"
                placeholder="mm/dd/yyyy"
                guide={false}
                mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                pipe={createAutoCorrectedDatePipe('mm dd yyyy')}
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <ControlLabel>Ticket Number</ControlLabel>
              <TicketInput
                value={ticketNumber}
                name="ticket_number"
                assigned="unassigned"
                onChange={this.handleValueChange}
              />
            </FormGroup>
          </Col>
        </Row>
        {ticketNumber && (
          <TicketFormWrapper
            onComplete={this.handleCreate}
            selectedItem={submissionItem}
            loading={loading}
            ticketNumber={ticketNumber}
            ticketNumberId={ticketNumber.id}
            date={date}
          />
        )}


        <Modal
          show={!!errorMessage}
          onHide={this.handleClearError}
          container={this}
          backdrop={false}
          aria-labelledby="contained-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title">Error</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {errorMessage}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClearError}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}


const CreateTicketMutation = gql`
  mutation CreateTicketMutation($input: TicketFormCreateInput!) {
    ticket_form_create(input: $input) {
      id
    }
  }
`;


const ItemQuery = gql`
  query SubmissionItem($id: Int!) {
    submission_item(id: $id) {
      id
    }
  }
`;

const withData = graphql(ItemQuery, {
  options: (props) => { return { variables: { id: props.selectedId } }; },
});


const withCreate = graphql(CreateTicketMutation, {
  name: 'createTicket',
  options: {
    refetchQueries: [
      {
        query: GetAllJobNumbersQuery,
        variables: {
          state: 'unreviewed',
          newer_than: moment().subtract(2, 'month').format('YYYY/MM/DD'),
        },
      },
      {
        query: AllTicketsQuery,
        variables: {
          assigned: 'unassigned',
        },
      },
    ],
  },
});

const withApi = compose(
  withData,
  withCreate,
);

TicketEntryLayout.propTypes = propTypes;

export default withApi(TicketEntryLayout);
